import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { useApi } from "../../../api"
import { ICargo, IPv } from "../../../interfaces"
import { walletSlideUpAtom } from "../../../stores/wallet"
import { Utils } from "../../../utils"
import { Numeral } from "../../Numeral"
import { WalletSlideUpEth } from "./Eth"
import { WalletSlideUpUsdt } from "./USDT"

export const WalletSlideUp = () => {
  const { t } = useTranslation()
  const api = useApi('NFT')

  const [isMounted, setMounted] = useState(false)
  const [expand, setExpand] = useRecoilState(walletSlideUpAtom)
  const [walletType, setWalletType] = useState<string>('ETH')
  const [gas, setGas] = useState<number>(0)
  const [nnego, setNnego] = useState<number>(0)

  const fetchCoins = useCallback(() => {
    if (!Utils().isLogin()) return;
    api.getCoinInfo((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        const pv: IPv = cargo.info;
        setGas(pv.gas)
        setNnego(pv.nonNegotiable)
      }
    })
  }, [api])

  useEffect(() => {
    if (!isMounted) {
      fetchCoins()
    }
    setMounted(true)
  }, [fetchCoins, isMounted])

  return (
    <>
      <div className={`
        ${expand ? 'scale-y-100' : 'scale-y-0'}
        ${expand ? 'opacity-1' : 'opacity-0'}
        transition
        duration-300
        absolute
        px-3
        bg-gray-700
        -left-10
        bottom-10
        rounded-t-lg
        text-gray-700
        origin-bottom
      `} style={{width: '280px'}}>
        <div className="d-flex justify-content-between align-items-center p-3 cursor-pointer" onClick={() => {
          setExpand(!expand);
        }}>
          <div className="text-white">
            <span className="material-icons-outlined mr-2" style={{ verticalAlign: 'bottom', }}>label</span>
            <span></span>
          </div>
          <span className="material-icons-outlined text-white">{expand ? 'expand_more' : 'expand_less'}</span>
        </div>
        <div className="bg2  flex justify-start text-white">
          <span className="pr-3 text-gray-400">{t('gas')} <span className="text-xl text-white"><Numeral value={gas} /></span></span>
          <span className="pr-3 text-gray-400">元寶 <span className="text-xl text-white"><Numeral value={nnego} /></span></span>
        </div>
        <div className="bg2">
          {walletType === 'ETH' && <WalletSlideUpEth />}
          {walletType === 'USDT' && <WalletSlideUpUsdt />}
        </div>
        <div className="bg2 flex justify-start text-white">
          <span className="p-3 cursor-pointer" onClick={() => { setWalletType('ETH') }}>ETH</span>
          <span className="p-3 cursor-pointer" onClick={() => { setWalletType('USDT') }}>USDT</span>
        </div>
      </div>
    </>
  )
}